'use strict';

document.addEventListener('DOMContentLoaded', function () {
  const video = document.getElementById('video');
  if (video) {
    const playlist = JSON.parse(video.getAttribute('data-playlist'));
    if (playlist.length > 0) {
      video.muted = true;
      video.autoplay = true;
      video.playsinline = true;
      video.controls = false;
      video.src = playlist[0];
      video.play();
      let index = 0;

      video.addEventListener('ended', function () {
        index++;
        if (index < playlist.length) {
          video.src = playlist[index];
          video.play();
        } else {
          video.src = playlist[0];
          video.play();
          index = 0;
        }
      });

      // 動画再生コントロール
      const toggler = document.getElementById('playPauseButton');
      if (toggler) {
        toggler.addEventListener('click', () => {
          const _class = toggler.classList;
          if (_class.contains('stop')) {
            _class.remove('stop');
            _class.add('start');
            document.getElementById('video').pause();
          } else {
            _class.remove('start');
            _class.add('stop');
            document.getElementById('video').play();
          }
        });
      }
    }
  }
});
